import { render, staticRenderFns } from "./promote-footer.vue?vue&type=template&id=a782c584&scoped=true&"
import script from "./promote-footer.vue?vue&type=script&lang=js&"
export * from "./promote-footer.vue?vue&type=script&lang=js&"
import style0 from "./promote-footer.vue?vue&type=style&index=0&id=a782c584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a782c584",
  null
  
)

export default component.exports